import { useQuery } from "@tanstack/react-query";
import api from "../api";

export const eventsQueryKey = ["events"];

async function fetchEventsRequest() {
  const res = await api.get(process.env.REACT_APP_FETCH_EVENTS_URL);
  return res.data;
}

export function useEventsQuery() {
  return useQuery({
    queryKey: eventsQueryKey,
    queryFn: fetchEventsRequest,
  });
}
